/* nb-c-ask-launcher.js
   Scoped, no library. Reveals the floating Ask launcher once its watched
   element (the buy box) has scrolled above the viewport, hides it again if
   the visitor scrolls back up. Plays one shimmer sweep the first time the
   reveal target (FAQ section) enters view. Delegated per-element init, safe
   to run again on shopify:section:load.
*/
(function () {
  function initLauncher(el) {
    if (el.hasAttribute('data-nb-init-ask-launcher')) return;
    el.setAttribute('data-nb-init-ask-launcher', 'true');

    var watchSel = el.getAttribute('data-nb-ask-launcher-watch');
    var revealSel = el.getAttribute('data-nb-ask-launcher-reveal');
    var watchEl = watchSel ? document.querySelector(watchSel) : null;
    var revealEl = revealSel ? document.querySelector(revealSel) : null;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var shimmered = false;

    el.removeAttribute('hidden');
    el.classList.remove('is-visible');

    if (watchEl && 'IntersectionObserver' in window) {
      var watchObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.boundingClientRect.top < 0 && !entry.isIntersecting) {
            el.classList.add('is-visible');
          } else if (entry.isIntersecting) {
            el.classList.remove('is-visible');
          }
        });
      }, { threshold: 0 });
      watchObserver.observe(watchEl);
    } else {
      el.classList.add('is-visible');
    }

    if (revealEl && 'IntersectionObserver' in window) {
      var revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !shimmered) {
            shimmered = true;
            if (!reduced) {
              var shimmer = document.createElement('span');
              shimmer.className = 'nb-c-ask-launcher__shimmer';
              shimmer.setAttribute('aria-hidden', 'true');
              el.appendChild(shimmer);
              window.setTimeout(function () {
                shimmer.remove();
              }, 1300);
            }
            revealObserver.disconnect();
          }
        });
      }, { threshold: 0.3 });
      revealObserver.observe(revealEl);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-nb-ask-launcher]').forEach(initLauncher);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
  if (document.readyState !== 'loading') initAll();
})();
